import { z } from "zod";
import { stripSearchParams, type SearchMiddleware } from "@tanstack/react-router";
import { UserRole, UserType } from "@/types/domain";
import {
  defaultPageSearch,
  optionalCalendarDay,
  optionalPage,
  optionalSearch,
} from "./shared";

const userSortSchema = z.enum([
  "createdAt:asc",
  "createdAt:desc",
  "email:asc",
  "email:desc",
  "firstname:asc",
  "firstname:desc",
  "lastname:asc",
  "lastname:desc",
  "userType:asc",
  "userType:desc",
  "userRole:asc",
  "userRole:desc",
]);

export const manageUsersSearchDefaults = {
  ...defaultPageSearch,
  sort: "createdAt:desc" as const,
};

export const manageUsersSearchSchema = z.object({
  nameContains: optionalSearch(z.string()),
  userType: optionalSearch(
    z.enum([
      UserType.Developer,
      UserType.Employee,
      UserType.Financier,
      UserType.Service,
    ]),
  ),
  userRole: optionalSearch(
    z.enum([UserRole.User, UserRole.Superuser, UserRole.Admin]),
  ),
  createdAfter: optionalCalendarDay,
  createdBefore: optionalCalendarDay,
  sort: optionalSearch(userSortSchema),
  page: optionalPage,
});

export type ManageUsersSearch = z.infer<typeof manageUsersSearchSchema>;

export const manageUsersSearchMiddlewares: SearchMiddleware<ManageUsersSearch>[] = [
  stripSearchParams(manageUsersSearchDefaults) as SearchMiddleware<ManageUsersSearch>,
];
